module.exports = __webpack_public_path__ + "img/gongan.5dff8cdd.png";